const SET_MODAL_CALENDAR_EVENT = (state, calendarEvent) => {
  state.modalCalendarEvent = calendarEvent;
};

const CALENDAR_EVENT_UPDATED = () => {
  //
};

const SET_MODAL_APPOINTMENT = (state, appointment) => {
  state.modalAppointment = appointment;
};

export default {
  SET_MODAL_CALENDAR_EVENT,
  CALENDAR_EVENT_UPDATED,
  SET_MODAL_APPOINTMENT,
};
